// eslint-disable-next-line import/no-extraneous-dependencies
import { writable } from 'svelte/store';
import { DEFAULT_RESPONSES } from './const';
export const { body } = window.document;
export const isTextAreaVisible = writable(false);
export const isOptionsAreaVisible = writable(true);
export const isReadingAreaVisible = writable(false);
export const isReviewAreaVisible = writable(false);
export const isReadingDoneAreaVisible = writable(false);
export const isSummaryAreaVisible = writable(false);
export const isURLAreaVisible = writable(false);
export const darkMode = writable(false);
export const open = writable(false);
export const text = writable('');
export const animationTime = writable('');
export const theme = localStorage.getItem('theme');
export const wpm = writable(localStorage.getItem('wpm') || '250');
export const font = writable(localStorage.getItem('font') || 'Times New Roman');
export const color = writable(localStorage.getItem('color') || (localStorage.getItem('theme') ? 'white' : 'black'));
export const size = writable(localStorage.getItem('font-size') || '16');
export const pauseBtnText = writable('Pause');
export const reviewResponses = writable(DEFAULT_RESPONSES);
